import { useEffect } from 'react';

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
}

export default function Seo({ title, description, keywords, canonical, ogImage }: SeoProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, attr = 'name') => {
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.content = content;
    };

    setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);

    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');
    if (ogImage) setMeta('og:image', ogImage, 'property');
    if (canonical) setMeta('og:url', canonical, 'property');

    setMeta('twitter:title', title, 'name');
    setMeta('twitter:description', description, 'name');
    if (ogImage) setMeta('twitter:image', ogImage, 'name');

    const linkEl = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (linkEl && canonical) linkEl.href = canonical;
  }, [title, description, keywords, canonical, ogImage]);

  return null;
}
